export default __webpack_public_path__ + "static/media/yield-data.436d72e0.svg";